import React from 'react';
import { AppContainer } from 'react-hot-loader';
import { render } from 'react-dom';
import configStore from './common/configStore';
import routeConfig from './common/routeConfig';
import Root from './Root';
// import 'bootstrap/dist/css/bootstrap.min.css';
import {I18nextProvider} from 'react-i18next';
import i18next from 'i18next';
import i18n from 'i18next';


Array.range= function(a, b, step){
  var A= [];
  if(typeof a== 'number'){
      A[0]= a;
      step= step || 1;
      while(a+step<= b){
          A[A.length]= a+= step;
      }
  }
  else{
      var s= 'abcdefghijklmnopqrstuvwxyz';
      if(a=== a.toUpperCase()){
          b=b.toUpperCase();
          s= s.toUpperCase();
      }
      s= s.substring(s.indexOf(a), s.indexOf(b)+ 1);
      A= s.split('');        
  }
  return A;
}


const store = configStore();
i18n
    .init({
        react: {
            useSuspense: false
        }
    });
function renderApp(app) {
  render(
    <I18nextProvider i18n={i18next}>
      <AppContainer>
        {app}
      </AppContainer>
    </I18nextProvider>,
    document.getElementById('root')
  );
}

renderApp(<Root store={store} routeConfig={routeConfig} />);

// Hot Module Replacement API
/* istanbul ignore if  */
if (module.hot) {
  module.hot.accept('./common/routeConfig', () => {
    const nextRouteConfig = require('./common/routeConfig').default; // eslint-disable-line
    renderApp(<Root store={store} routeConfig={nextRouteConfig} />);
  });
  module.hot.accept('./Root', () => {
    const nextRoot = require('./Root').default; // eslint-disable-line
    renderApp(<Root store={store} routeConfig={routeConfig} />);
  });
}



// WEBPACK FOOTER //
// ./src/index.js